import { IDynamicFormWidgetSection } from '@components/dynamic-form/types';
import { FormFieldType } from '@components/dynamic-form/types/inputTypes';
import { isEmpty } from '@utils/validationUtils';

export const initialValues = {
  sublineId: '',
  lineId: '',
  lineName: '',
  sublineName: '',
  sublineExternalCode: '',
  arabicName: '',
  sublineCategory: '',
  sublineStatus: '',
};

export const drawerSections: IDynamicFormWidgetSection[] = [
  {
    inputs: {
      lineName: {
        name: 'lineName',
        title: 'Line',
        type: FormFieldType.select,
        placeholder: 'Line',
        value: !isEmpty(initialValues.lineName) ? initialValues.lineName : '',
        selectOptions: {},
        disabled: false,
        required: true,
      },
      sublineName: {
        name: 'sublineName',
        title: 'Subline Name',
        type: FormFieldType.text,
        placeholder: 'Subline Name',
        value: !isEmpty(initialValues.sublineName)
          ? initialValues.sublineName
          : '',
        required: true,
      },
      sublineExternalCode: {
        name: 'sublineExternalCode',
        title: 'External Code',
        type: FormFieldType.text,
        placeholder: 'External Code',
        value: !isEmpty(initialValues.sublineExternalCode)
          ? initialValues.sublineExternalCode
          : '',
        required: true,
      },
      arabicName: {
        name: 'arabicName',
        title: 'Arabic Name',
        type: FormFieldType.text,
        placeholder: 'Arabic Name',
        value: !isEmpty(initialValues.arabicName)
          ? initialValues.arabicName
          : '',
        required: true,
      },
      sublineCategory: {
        name: 'sublineCategory',
        title: 'Category',
        placeholder: 'Category',
        type: FormFieldType.select,
        value: !isEmpty(initialValues.sublineCategory)
          ? initialValues.sublineCategory
          : '',
        selectOptions: {},
        required: true,
        hidden: false,
      },
      sublineStatus: {
        name: 'sublineStatus',
        title: 'Status',
        placeholder: 'Status',
        type: FormFieldType.select,
        value: !isEmpty(initialValues.sublineStatus)
          ? initialValues.sublineStatus
          : 'INACTIVE',
        selectOptions: {},
        required: false,
        hidden: true,
      },
    },
  },
];
